document.addEventListener('turbo:load', function() {
const sidebar = document.getElementById('sidebar');
const sidebarToggle = document.getElementById('sidebarToggle');
const sidebarOverlay = document.getElementById('sidebarOverlay');
const menuIcon = document.getElementById('menuIcon');
const closeIcon = document.getElementById('closeIcon');

function toggleSidebar() {
  sidebar.classList.toggle('-translate-x-full');
  sidebarOverlay.classList.toggle('opacity-0');
  sidebarOverlay.classList.toggle('pointer-events-none');
  sidebarOverlay.classList.toggle('opacity-50');

  // Toggle between hamburger and close icons
  menuIcon.classList.toggle('hidden');
  closeIcon.classList.toggle('hidden');

  // Move toggle button to the right side when sidebar is open
  if (!sidebar.classList.contains('-translate-x-full')) {
    sidebarToggle.classList.add('left-auto', 'right-1');
    sidebarToggle.classList.remove('left-0');
  } else {
    sidebarToggle.classList.add('left-0');
    sidebarToggle.classList.remove('left-auto', 'right-1');
  }
}

if (sidebarToggle) {
  sidebarToggle.addEventListener('click', toggleSidebar);
}

if (sidebarOverlay) {
  sidebarOverlay.addEventListener('click', toggleSidebar);
}
});